import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import test from '@/components/test'
import Voyage from '@/components/voyage/Voyage'
import VoyageResult from '@/components/voyage/VoyageResult'
// 客户应用的
import FreightPrice from '@/components/kehu/freightPrice/FreightPrice'
import FreightPriceResult from '@/components/kehu/freightPrice/FreightPriceResult'
import Business from '@/components/kehu/business/Business'
import BusinessResult from '@/components/kehu/business/businessResult/BusinessResult'
import ShipperOrder from '@/components/kehu/shipperOrder/ShipperOrder'
// 业务应用的
import Vehicletracking from '@/components/yewu/vehicletracking/Vehicletracking'
import VehicletrackingResult from '@/components/yewu/vehicletracking/VehicletrackingResult'
import Quote from '@/components/yewu/quote/quote'
import QuoteResult from '@/components/yewu/quote/quoteResult/QuoteResult'
import Order from '@/components/yewu/order/Order'
// 司机应用
import Plan from '@/components/siji/plan/Plan'
import ReportNoList from '@/components/siji/reportContNo/ReportNoList'
import ReportContNo from '@/components/siji/reportContNo/ReportContNo'
import LoadImgList from '@/components/siji/loadImg/LoadImgList'
import LoadImgLading from '@/components/siji/loadImg/LoadImgLading'
import LoadImgUpload from '@/components/siji/loadImg/LoadImgUpload'
import LoadImgUploadZJDLD from '@/components/siji/loadImg/LoadImgUploadZJDLD'
import LoadImgLook from '@/components/siji/loadImg/LoadImgLook'
import DeliveImgList from '@/components/siji/deliveImg/DeliveImgList'
import DeliveImgLading from '@/components/siji/deliveImg/DeliveImgLading'
import DeliveImgUpload from '@/components/siji/deliveImg/DeliveImgUpload'
import DeliveImgLook from '@/components/siji/deliveImg/DeliveImgLook'
import FeeMaintainList from '@/components/siji/feeMaintain/FeeMaintainList'
import FeeMaintain from '@/components/siji/feeMaintain/FeeMaintain'
import ViewPictureList from '@/components/kehu/viewPicture/ViewPictureList.vue'
import ViewPicture from '@/components/kehu/viewPicture/ViewPicture.vue'
import LocationUploadList from '@/components/siji/locationUpdate/LocationUploadList.vue'
import LocationUpload from '@/components/siji/locationUpdate/LocationUpload.vue'
import demurrageQueryList from "@/components/kehu/demurrageQuery/demurrageQueryList.vue"
// import LoadUploadResult from '@/components/siji/loadImg/LoadUploadResult'
// import DeliveUploadResult from '@/components/siji/deliveImg/DeliveUploadResult'

Vue.use(Router);

export default new Router({
    routes: [{
        path: '/test',
        name: 'test',
        component: test
    },
        {
            path: '/',
            name: 'index',
            component: Home
        }, {
            path: '/home',
            name: 'Home',
            component: Home
        }, {
            path: '/voyage-kehu',
            name: 'VoyageKehu', // 客户的船期查询
            component: Voyage
        }, {
            path: '/voyage-yewu',
            name: 'VoyageYewu', // 业务的船期查询
            component: Voyage
        }, {
            path: '/voyage-result',
            name: 'VoyageResult', // 船期查询的结果界面
            component: VoyageResult
        }, {
            path: '/freight-price',
            name: 'FreightPrice',
            component: FreightPrice
        }, {
            path: '/freight-price-result',
            name: 'FreightPriceResult',
            component: FreightPriceResult
        }, {
            path: '/business',
            name: 'Business',
            component: Business
        }, {
            path: '/business-result',
            name: 'BusinessResult',
            component: BusinessResult
        }, {
            path: '/shipper-order',
            name: 'ShipperOrder',
            component: ShipperOrder
        }, {
            path: '/vehicletracking',
            name: 'Vehicletracking',
            component: Vehicletracking
        }, {
            path: '/vehicletracking-result',
            name: 'VehicletrackingResult',
            component: VehicletrackingResult
        }, {
            path: '/quote',
            name: 'Quote',
            component: Quote
        }, {
            path: '/quote-result',
            name: 'QuoteResult',
            component: QuoteResult
        }, {
            path: '/order',
            name: 'Order',
            component: Order
        }, {
            path: '/today-plan',
            name: 'TodayPlan',
            component: Plan
        }, {
            path: '/tomorrow-plan',
            name: 'TomorrowPlan',
            component: Plan
        }, {
            path: '/report-no-list',
            name: 'ReportNoList',
            component: ReportNoList
        }, {
            path: '/report-cont-no',
            name: 'ReportContNo',
            component: ReportContNo
        }, {
            path: '/load-img-list',
            name: 'LoadImgList',
            component: LoadImgList
        }, {
            path: '/load-img-lading',
            name: 'LoadImgLading',
            component: LoadImgLading
        }, {
            path: '/load-img-upload',
            name: 'LoadImgUpload',
            component: LoadImgUpload
        }, {
            path: '/load-img-uploadZJDLD',
            name: 'LoadImgUploadZJDLD',
            component: LoadImgUploadZJDLD
        }, {
            path: '/load-img-look',
            name: 'LoadImgLook',
            component: LoadImgLook
        }, {
            path: '/delive-img-list',
            name: 'DeliveImgList',
            component: DeliveImgList
        }, {
            path: '/delive-img-lading',
            name: 'DeliveImgLading',
            component: DeliveImgLading
        }, {
            path: '/delive-img-upload',
            name: 'DeliveImgUpload',
            component: DeliveImgUpload
        }, {
            path: '/delive-img-look',
            name: 'DeliveImgLook',
            component: DeliveImgLook
        }, {
            path: '/fee-maintain-list',
            name: 'FeeMaintainList',
            component: FeeMaintainList
        }, {
            path: '/fee-maintain',
            name: 'FeeMaintain',
            component: FeeMaintain
        }, {
            path: '/view-picture-list',
            name: 'ViewPictureList',
            component: ViewPictureList
        }, {
            path: '/view-picture',
            name: 'ViewPicture',
            component: ViewPicture
        }, {
            path: '/location-upload-list',
            name: 'LocationUploadList',
            component: LocationUploadList
        }, {
            path: '/location-upload',
            name: 'LocationUpload',
            component: LocationUpload
        }, {
            path: '/demurrage-query-list',
            name: 'demurrageQueryList',
            component: demurrageQueryList
        }
        // {
        //   path: '/load-upload-result',
        //   name: 'LoadUploadResult',
        //   component: LoadUploadResult
        // },
        // {
        //   path: '/delive-upload-result',
        //   name: 'DeliveUploadResult',
        //   component: DeliveUploadResult
        // },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js